export const endPoints = {
  CONTRACT_CHANGES: '/v1/contract/changes',
  BUILDING: '/v1/building',
  FLAT: 'v1/flat/changes',
  CONTRACT_CHANGES_EMPLOYEE: '/v1/contract/changes/employee',
  CLIENT_CHANGES: '/v1/client/changes',
  CLIENT_CHANGES_NATURAL: '/v1/client/changes/natural',
  CLIENT_CHANGES_JURIDICAL: '/v1/client/changes/juridical'
};
